import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

import { useLocations } from "../../hooks/useLocations";
import Input from "../common/Input";
import DatePicker from "../common/DatePicker";
import LanguageSelector from "../LanguageSelector";
import ButtonNext from "../ButtonNext";

const Step0 = ({ bookingData, setBookingData, onComplete }) => {
  const { t } = useTranslation();
  const locations = useLocations();

  const [showDatePicker, setShowDatePicker] = useState(false);
  const [isButtonNextDisabled, setIsButtonNextDisabled] = useState(true);

  const getBookingTypeByCode = (code) => {
    if (/^DG\d+$/.test(code) || locations.find(location => code.startsWith(location.codice))) {
      return "codice";
    }
    return code.length > 0 ? "voucher" : "";
  }

  const handleCodeChange = (field, value) => {
    const bookingCode = value.replace(/\s/g, "").toUpperCase();
    setBookingData((prevData) => ({
      ...prevData,
      [field]: bookingCode,
      type: getBookingTypeByCode(bookingCode)
    }));
  };

  const handleNextStep = (e) => {
    e.preventDefault();
    if (bookingData.type === "codice") {
      setShowDatePicker(true);
      return;
    }
    onComplete();
  };

  const handleDateChange = (value) => {
    setBookingData((prevData) => ({
      ...prevData,
      date: value
    }));
    onComplete();
  };

  useEffect(() => {
    setIsButtonNextDisabled(!bookingData.code);
  }, [bookingData.code]);

  return (
    <form className="step step--0" onSubmit={handleNextStep}>
      <LanguageSelector />
      <h1 className="step__title">{t("step0.title")}</h1>
      <p className="step__subtitle">{t("step0.subtitle")}</p>
      <div className="step__content">
        <Input
          type="text"
          name="code"
          label={t("booking.code.label")}
          placeholder={t("booking.code.placeholder")}
          value={bookingData.code || ""}
          onChange={handleCodeChange}
        />
      </div>
      <ButtonNext disabled={isButtonNextDisabled} />
      {showDatePicker && (
        <DatePicker
          label={t("booking.date.helper")}
          selectedDate={bookingData.date || ""}
          minDate={dayjs().subtract(5, "year").toDate()}
          maxDate={dayjs().add(5, "year").toDate()}
          onChange={handleDateChange}
          onClickOutside={() => setShowDatePicker(false)}
        />
      )}
    </form>
  );
};

export default Step0;
